'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// sizes, proportions assumed by the mockup
var GROUPS_GAP_INDEX = exports.GROUPS_GAP_INDEX = 1.7;
var LABELS_OFFSET = exports.LABELS_OFFSET = 10;
var CHART_OFFSET_FACTOR = exports.CHART_OFFSET_FACTOR = 3;

var getDataType = exports.getDataType = function getDataType() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var fieldName = arguments[1];

  var isDataString = Boolean(data.length === 0 || typeof data[0][fieldName] === 'string');

  if (isDataString) {
    return 'category';
  }

  return 'number';
};

var generateGridLinePoints = exports.generateGridLinePoints = function generateGridLinePoints(_ref) {
  var elementsLength = _ref.elementsLength,
      barSize = _ref.barSize,
      size = _ref.size;

  var barsHeight = Math.max(1, elementsLength) * barSize;
  var lineStep = barsHeight + GROUPS_GAP_INDEX * barSize;
  var horizontalLinesYPoints = [];
  var lastLineY = size - 2 * LABELS_OFFSET;
  var nextLineY = 0;

  while (nextLineY < lastLineY) {
    horizontalLinesYPoints.push(nextLineY);
    nextLineY += lineStep;
  }

  return horizontalLinesYPoints;
};

var calculateChartHeight = exports.calculateChartHeight = function calculateChartHeight(_ref2) {
  var categoriesLength = _ref2.categoriesLength,
      elementsLength = _ref2.elementsLength,
      barSize = _ref2.barSize,
      categoryGapSize = _ref2.categoryGapSize;
  return Number(categoriesLength * (elementsLength * barSize) + categoriesLength * categoryGapSize + CHART_OFFSET_FACTOR * LABELS_OFFSET);
};